import { useDitUploadSource } from './useDitUploadSource';
import { useDitStartIngestion } from './useDitStartIngestion';
import { useDitAbortEvent } from './useDitAbortEvent';
import { useDitCreateEvent } from './useDitCreateEvent';

export const useDitIngestionFlow = () => {
  const { uploadDitSource, loading: uploading, error: uploadError } = useDitUploadSource();
  const { startDitIngestion, loading: starting, error: startError } = useDitStartIngestion();
  const { abortDitEvent, loading: aborting, error: abortError } = useDitAbortEvent();
  const { createDitEvent, loading: creating, error: createError } = useDitCreateEvent();

  const loading = creating || uploading || starting || aborting;
  const error = createError || uploadError || startError || abortError;

  const runIngestionFlow = async ({ countryIsoCode, sourceId, sourceFiles }) => {
    let newEventId;

    try {
      const { data: createEventData } = await createDitEvent({
        countryIsoCode,
        sourceId,
        sourceFiles: Object.entries(sourceFiles).map(([tag, file]) => ({
          tag,
          filename: file.name,
        })),
      });

      const { eventId, presignedUrls } = createEventData.ditCreateEvent;
      newEventId = eventId;

      await Promise.all(
        Object.entries(sourceFiles).map(([tag, file]) => {
          return uploadDitSource({
            file,
            presignedUrl: presignedUrls[tag],
          });
        }),
      );

      await startDitIngestion({ eventId });

      return { success: true, eventId };
    } catch (err) {
      if (newEventId) {
        try {
          await abortDitEvent({ eventId: newEventId, message: err.message });
        } catch (abortErr) {
          return { success: false, error: err, abortError: abortErr };
        }
      }
      return { success: false, error: err };
    }
  };

  return { runIngestionFlow, loading, error };
};
